import React from "react";
import Subtitle from "@radarly/components/cards/card/subtitle";
import { DatavizMap } from "@radarly/models/dataviz";
import { SearchFragmentGeo, getTermFromAggs } from "@radarly/models/search";
import Date from "@radarly/shared/cards/subtitle/date";
import Metric from "@radarly/shared/cards/subtitle/metric";
import Tile from "@radarly/shared/cards/tile";
import Map from "@radarly/shared/widgets/geo/map";
import { CardFragmentProps } from "../model";

const RadarlyGeoCardsMap = ({
  title,
  fragment,
  project,
  dataviz,
  height,
  onClickItem,
  onGenerateCSV,
  timezone,
  forceReload,
  nowDate,
}: CardFragmentProps<SearchFragmentGeo, DatavizMap>) => {
  const term = getTermFromAggs(fragment.request.aggs);
  const metric = fragment.request.aggs[term].metrics[0];
  return (
    <Tile
      title={title}
      height={height}
      subtitle={
        <Subtitle
          meta={[
            <Date fragment={fragment} timezone={timezone} nowDate={nowDate} />,
            <Metric metric={metric} />,
          ]}
        />
      }
      clause={fragment.request.query}
      onGenerateCSV={onGenerateCSV}
      isPNG
    >
      <Map
        fragment={fragment}
        project={project.id}
        dataviz={dataviz}
        onClickItem={onClickItem}
        forceReload={forceReload}
      />
    </Tile>
  );
};

export default RadarlyGeoCardsMap;
